export default "__VITE_ASSET__B8nmNnp3__"